export default {"src":"/_next/static/media/HeartLight.d528fdb7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};